import type { Dispatch, FormEvent, SetStateAction } from 'react';
import { useTranslation } from 'react-i18next';

export interface ModelScopeOption {
  key: string;
  label: string;
}

interface PartnerModelScopeTabProps {
  modelScopeOptions: ModelScopeOption[];
  modelScopeOptionKeys: Set<string>;
  selectedModelKeys: string[];
  busy: boolean;
  setModelKeys: Dispatch<SetStateAction<string[]>>;
  onSave: (event: FormEvent) => void;
}

export function PartnerModelScopeTab({
  modelScopeOptions,
  modelScopeOptionKeys,
  selectedModelKeys,
  busy,
  setModelKeys,
  onSave
}: PartnerModelScopeTabProps) {
  const { t } = useTranslation();
  return (
    <section className="panel">
      <h3>{t('partners.modelScope')}</h3>
      <form onSubmit={onSave}>
        <div className="model-list">
          {modelScopeOptions.map((option) => (
            <label key={option.key} className="check-row">
              <input
                type="checkbox"
                checked={selectedModelKeys.includes(option.key)}
                onChange={(event) =>
                  setModelKeys((current) =>
                    event.target.checked
                      ? [...new Set([...current.filter((key) => modelScopeOptionKeys.has(key)), option.key])]
                      : current.filter((key) => modelScopeOptionKeys.has(key) && key !== option.key)
                  )
                }
              />
              <span>
                <strong>{option.label}</strong>
                <small>{option.key}</small>
              </span>
            </label>
          ))}
          {modelScopeOptions.length === 0 && <p className="muted">{t('partners.noModelScopeOptions')}</p>}
        </div>
        <div className="form-actions">
          <button disabled={busy}>{t('partners.saveModelScope')}</button>
        </div>
      </form>
      <p className="muted">{t('partners.modelScopeHint')}</p>
    </section>
  );
}
